import React from 'react';
import { Form } from '@ant-design/compatible';
import { Input, message, Modal } from 'antd';
import { COMPANY_CREATE_ERROR, COMPANY_CREATE_SUCCESS } from './../../../../actions/Company';
const FormItem = Form.Item;

class CreateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmDirty: false,
    };
  }

  /**
   * Action success & errors handling
   * @param prevProps - previous props from earlier state
   */
  componentDidUpdate(prevProps) {
    this.handleActionResponseNotifications(this.props.actionResponse);
  }

  /**
   * Handles notifications for the action response
   * @param actionResponse - the response of the action made
   */
  handleActionResponseNotifications(actionResponse) {
    if (actionResponse === null) {
      return;
    }

    switch (actionResponse.get('type')) {
      case COMPANY_CREATE_ERROR:
        message.error('Der er opstået en fejl, prøv igen.');
        break;

      case COMPANY_CREATE_SUCCESS:
        message.success('Virksomheden blev oprettet.');
        this.handleCancel();
        break;

      default:
        break;
    }
    this.props.clearActionResponse();
  }

  /**
   * Validates & submits data to backend
   * @param e is the submit button.
   */
  handleSubmit = (e) => {
    e.preventDefault();
    const { onCreate } = this.props;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { name, clientId, clientSecret } = values;
        const company = { name, clientId, clientSecret };
        onCreate(company);
      }
    });
  };

  /**
   * Closes create window & resets all fields on cancel
   */
  handleCancel = () => {
    this.props.onCancel();
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8, textAlign: 'left' },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };

    return (
      <Modal
        width={'50%'}
        visible={this.props.visible}
        title={'Opret ny virksomhed'}
        okText={'Opret'}
        cancelText={'Annuller'}
        onCancel={this.handleCancel}
        onOk={this.handleSubmit}
        confirmLoading={this.props.isLoading}
      >
        <Form>
          <FormItem {...formItemLayout} label={'Virksomhedsnavn'}>
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: 'Virksomhedsnavn skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Klientid'}>
            {getFieldDecorator('clientId', {
              rules: [
                {
                  required: true,
                  message: 'Klientid skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>
          <FormItem {...formItemLayout} label={'Klientnøgle'}>
            {getFieldDecorator('clientSecret', {
              rules: [
                {
                  required: true,
                  message: 'Klientnøgle skal udfyldes.',
                  whitespace: true,
                },
              ],
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(CreateForm);
